import { memo } from 'react'
import { OrderbookList } from '../../views/Spot/OrderList/style'
import Loading from '../Loading'
import { styled } from '@mui/material'

const OrderbookPendingWrap = styled(OrderbookList)`
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.color.primary20};
`

export const OrderbookPending = memo(() => {
  return (
    <OrderbookPendingWrap>
      <Loading size={18} />
    </OrderbookPendingWrap>
  )
})
